/* Polsk katalog for locale-transaction-detail-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'transaction.annulBy': 'Anulowane przez',
  "transaction.annulAudit": "Historia anulowania",
  "transaction.annulledAt": "Data anulowania",
  "transaction.annulReason": "Powód",
  "transaction.annulActor": "Identyfikator użytkownika",
  "transaction.reversalDate": "Data księgowania zapisu odwracającego",
  "transaction.openOriginal": "Otwórz pierwotny zapis",
  "transaction.openReversal": "Otwórz zapis odwracający",
  "transaction.auditMissing": "Nie zapisano",
  "transaction.reversalMissing": "Zapis odwracający nie jest dostępny we wczytanym dzienniku.",
  "transaction.auditDebit": "Winien",
  "transaction.auditCredit": "Ma",

  'transaction.incompleteBasis': 'Pokrycie dziennika jest niekompletne. Ten dowód księgowy jest wyświetlany do celów dokumentacji i diagnostyki; sum nie należy traktować jako kompletnych.',
  'route.transaction': 'Transakcja',
  'transaction.back': 'Wróć do wszystkich transakcji',
  'transaction.title': 'Transakcja',
  'transaction.posting': 'Księgowanie',
  'transaction.summary': 'Podsumowanie – kwoty na konta i z kont',
  'transaction.account': 'Konto',
  'transaction.incoming': 'Na konto',
  'transaction.outgoing': 'Z konta',
  'transaction.total': 'Suma',
  'transaction.description': 'Opis',
  'transaction.links': 'Powiązane pozycje',
  'transaction.sourceLead': 'To jest księgowanie dla',
  'transaction.sourceHelp': 'Otwórz źródło, jeśli chcesz zmienić transakcję lub powiązaną płatność.',
  'transaction.relatedPayments': 'Powiązane płatności',
  'transaction.correctionReplacement': 'Dowód zastępczy',
  'transaction.correctionOriginal': 'Pierwotny dowód',
  'transaction.correctionReason': 'Przyczyna korekty',
  'transaction.created': 'Utworzono',
  'transaction.by': 'przez',
  'transaction.vatCodes': 'Kody VAT',
  'transaction.accountNumber': 'Nr konta',
  'transaction.name': 'Nazwa',
  'transaction.amount': 'Kwota',
  'transaction.documentation': 'Dokumentacja',
  'transaction.generatedDocument': 'Dokument faktury jest generowany, gdy go otworzysz lub pobierzesz.',
  'transaction.noDocumentation': 'Do tej transakcji nie dołączono dokumentacji.',
  'transaction.open': 'Otwarte księgowanie',
  'transaction.locked': 'Zablokowane księgowanie',
  'transaction.annulled': 'Anulowano',
  'transaction.fallbackType': 'Księgowanie',
  'transaction.notFound': 'Nie znaleziono transakcji',
  'transaction.notFoundHelp': 'Transakcja mogła zostać anulowana, należeć do innego roku obrotowego lub nie być już dostępna.',
  'transaction.invoice': 'Faktura',
  'transaction.purchase': 'Zakup',
  'transaction.otherSale': 'Inna sprzedaż',
  'transaction.customs': 'Zgłoszenie celne',
  'transaction.openDocument': 'Zobacz dokument',
  'transaction.download': 'Pobierz',
  'transaction.upload': 'Prześlij załącznik',
  'transaction.uploaded': 'Załącznik przesłany.',
  'transaction.uploadFailed': 'Nie udało się przesłać załącznika.',
  'transaction.documentFailed': 'Nie udało się pobrać dokumentu z serwera.',
  'transaction.previewFailed': 'Nie udało się wyświetlić dokumentu.',
  'transaction.lost': 'Brak dokumentu',
  'transaction.lostPrompt': 'Wyjaśnienie do dziennika (opcjonalnie):',
  'transaction.lostSaved': 'Dokument oznaczono jako zaginiony.',
  'transaction.lostFailed': 'Nie udało się oznaczyć dokumentu jako zaginionego.',
  'transaction.annul': 'Anuluj transakcję',
  'transaction.annulQuestion': 'Anulować transakcję?',
  'transaction.creditQuestion': 'Wystawić korektę faktury?',
  'transaction.credit': 'Wystaw korektę',
  'transaction.annulling': 'Anulowanie...',
  'transaction.annulHelp': 'Transakcja zostanie anulowana i zachowana w historii, ale nie zostanie uwzględniona w podstawie raportów.',
  'transaction.creditHelp': 'Do faktury zostanie wystawiona faktura korygująca, utworzona jako szkic do sprawdzenia przed wysłaniem.',
  'transaction.creditDraft': 'Faktura korygująca została utworzona jako szkic. Sprawdź ją i wyślij z listy faktur.',
  'transaction.annulledSaved': 'Transakcja została anulowana.',
  'transaction.annulFailed': 'Nie udało się anulować transakcji.',
  'transaction.privateReimbursed': 'Prywatny wydatek został zwrócony.',
  'transaction.privateReimburseFailed': 'Nie udało się zwrócić prywatnego wydatku.',
  'transaction.reimbursePrivate': 'Zwróć prywatny wydatek',
  'transaction.reimbursePrivateHelp': 'Księguje zwrot z wybranego firmowego rachunku bankowego na konto 2060 bez ponownego księgowania kosztu ani VAT.',
  'transaction.paymentDate': 'Data płatności',
  'transaction.bankAccount': 'Rachunek bankowy',
  'transaction.goTo': 'Przejdź do',
  'transaction.bank': 'Bank',
  'transaction.vat': 'VAT',
  'transaction.yearEnd': 'Zamknięcie roku',
});
